export default __webpack_public_path__ + "static/media/events-report-icon.73cea23c.svg";